import { render, staticRenderFns } from "./AutoAssessmentForm.vue?vue&type=template&id=7b384a66"
import script from "./AutoAssessmentForm.vue?vue&type=script&lang=js"
export * from "./AutoAssessmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports